export type SignupRequest = {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    password: string;
    acceptedTerms: boolean;
    acceptedPrivacyPolicy: boolean;
};

export type SignupFormData = SignupRequest & {
    passwordAgain: string;
    acceptedTerms: boolean;
    acceptedPrivacyPolicy: boolean;
};

export function createSignupRequestFromFormData(
    formData: SignupFormData,
): SignupRequest {
    const {
        firstName,
        lastName,
        email,
        phone,
        password,
        acceptedTerms,
        acceptedPrivacyPolicy,
    } = formData;

    return {
        firstName,
        lastName,
        email,
        phone,
        password,
        acceptedTerms,
        acceptedPrivacyPolicy,
    };
}
